import React, { useEffect } from 'react';
import Fade from 'react-reveal/Fade';
import CompletedIllustration from 'assets/images/completed.jpg';

export default function Completed() {
  useEffect(() => {
    // Hapus localStorage saat step ini dirender
    localStorage.removeItem("checkoutData");
    localStorage.removeItem("pageData");
  }, []);

  return (
    <Fade>
      <div className="container" style={{ marginBottom: 30 }}>
        <div className="row justify-content-center text-center">
          {/* Kolom utama */}
          <div className="col-12 col-md-6 col-lg-4 px-3">
            <img
              src={CompletedIllustration}
              className="img-fluid mb-4"
              alt="completed checkout apartment"
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "10px",
              }}
            />
            <p
              className="text-gray-500"
              style={{
                fontSize: window.innerWidth <= 576 ? "14px" : "16px",
                lineHeight: "1.6",
                padding: window.innerWidth <= 576 ? "0 10px" : "0",
              }}
            >
              We will inform you via email later once the transaction has been accepted.
            </p>
          </div>
        </div>
      </div>
    </Fade>
  );
}
